module.exports = __webpack_public_path__ + "bcc66728cb9b28853adeaaa4ab64c270.pdf";